<div class="dev-login-overlay">
  <div class="dev-login-card">
    <div class="dev-login-header">
      <span class="dev-login-badge">LOCAL DEV</span>
      <h2 class="dev-login-title">Paste your Cognito Access Token</h2>
      <p class="dev-login-hint">
        Log in to <strong>dev.dx.arrk.com</strong>, open DevTools → Application → Cookies
        and copy the <code>accessToken</code> value.
      </p>
    </div>
    <textarea
      pTextarea
      [(ngModel)]="tokenInput"
      rows="6"
      placeholder="eyJraWQiOi..."
      class="dev-login-textarea"
      (keydown.enter)="$event.preventDefault()"
    ></textarea>
    @if (error) {
      <p class="dev-login-error">{{ error }}</p>
    }
    <p-button
      label="Save token & continue"
      icon="pi pi-key"
      [disabled]="!tokenInput.trim()"
      (onClick)="onSave()"
      styleClass="dev-login-btn"
    />
  </div>
</div>
